module.exports = __webpack_public_path__ + "static/media/revolt.884c5df9.jpg";